import axios from "axios";
import { store } from "../store";
import {
  REQUEST_LOGOUT,
  UNAUTHENTICATED,
} from "../store/definitions/authConstants";
import * as ApiRoutes from "../routes/routeConstants/apiRoutes";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import UserService from "../services/AuthService/auth.service";
import { appHistory } from "../routes";
import { LOGIN } from "../routes/routeConstants/appRoutes";
import { LocalStorage } from "../shared/utils/LocalStorageHelpers";
export const getHeaders = (): any => {
  let headers, user;
  if (localStorage.getItem("token")) {
    user = JSON.parse(localStorage.getItem("token") || "");
  }
  headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      user && user.access_token ? user.access_token : ""
    }`,
  };
  return headers;
};

const axiosInstance = axios.create({
  baseURL: ApiRoutes.BASE_URL,
  timeout: 60000,
});

axiosInstance.interceptors.request.use(function (config) {
  const headers = getHeaders();
  if (config.headers) {
    config.headers["Authorization"] = headers["Authorization"];
  } else {
    config.headers = headers;
  }
  config.data = config.data ? config.data : {};
  return config;
});

// const refreshAuthToken = (failedRequest: any) => {
//   let accessDetails;
//   if (localStorage.getItem("token")) {
//     accessDetails = JSON.parse(localStorage.getItem("token") || "");
//   }

//   let oldRefreshToken =
//     accessDetails && accessDetails.refresh_token
//       ? accessDetails.refresh_token
//       : "";

//   let data = {
//     admin: {
//       grant_type: "refresh_token",
//       refresh_token: oldRefreshToken,
//     },
//   };

//   return UserService.loginUser(
//     data,
//     (userDetails: any, accessDetails: any) => {
//       failedRequest.response.config.headers["Authorization"] =
//         "Bearer " + accessDetails.auth_token;
//       return Promise.resolve();
//     },
//     (error: any) => {
//       localStorage.clear();
//       window.location.reload();
//       store.dispatch({
//         type: UNAUTHENTICATED,
//         payload: {
//           authenticated: false,
//         },
//       });
//       appHistory.push(LOGIN);
//     },
//     () => {}
//   );
// };

// createAuthRefreshInterceptor(axiosInstance, refreshAuthToken);

axiosInstance.interceptors.response.use(
  (response): any => {
    return {
      data: response.data,
      message: response.statusText,
      status: response.status,
    };
  },
  (error) => {
    const { response } = error;
    if (response?.status == 401) {
        // localStorage.clear();
        // window.location.reload();
        // store.dispatch({
        //   type: UNAUTHENTICATED,
        //   payload: {
        //     authenticated: false,
        //   },
        // });
        // appHistory.push(LOGIN);
      const originalRequest = error?.config;
      originalRequest._retry = true;
      const refreshToken = LocalStorage?.getItem("token")?.refresh_token;
      localStorage.clear();
      const payload = {
        admin: {
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        },
      };
      return UserService.loginUser(
        payload,
        (userDetails: any, accessDetails: any) => {
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + accessDetails.auth_token;
          originalRequest.headers["Authorization"] =
            "Bearer " + accessDetails.auth_token;
          return axios(originalRequest);
        },
        (error: any) => {
          localStorage.clear();
          window.location.reload();
          store.dispatch({
            type: UNAUTHENTICATED,
            payload: {
              authenticated: false,
            },
          });
          appHistory.push(LOGIN);
        },
        () => {}
      );
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
